import { render, staticRenderFns } from "./CreateKeywordForm.vue?vue&type=template&id=5ad8eb50"
import script from "./CreateKeywordForm.vue?vue&type=script&lang=js"
export * from "./CreateKeywordForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports